import { useEffect, useState } from "react";

import { fetchPredictions } from "../api";
import { NormalizedPrediction, NormalizedScheduledGame, NormalizedWithheldGame } from "../types";

interface PredictionsState {
  loading: boolean;
  error: string | null;
  data: {
    predictions: NormalizedPrediction[];
    withheldGames: NormalizedWithheldGame[];
    scheduledGames: NormalizedScheduledGame[];
    withheldGamesCount: number;
    scheduledGamesCount: number;
    lastUpdatedAt: string | null;
    runDate: string | null;
  } | null;
  stale: boolean;
  partial: boolean;
}

export function usePredictions(): PredictionsState {
  const [state, setState] = useState<PredictionsState>({
    loading: true,
    error: null,
    data: null,
    stale: false,
    partial: false,
  });

  useEffect(() => {
    const controller = new AbortController();

    fetchPredictions(controller.signal)
      .then((result) => {
        setState({
          loading: false,
          error: null,
          data: {
            predictions: result.predictions,
            withheldGames: result.withheldGames,
            scheduledGames: result.scheduledGames,
            withheldGamesCount: result.withheldGamesCount,
            scheduledGamesCount: result.scheduledGamesCount,
            lastUpdatedAt: result.lastUpdatedAt,
            runDate: result.runDate,
          },
          stale: result.stale,
          partial: result.partial,
        });
      })
      .catch((error: Error) => {
        if (controller.signal.aborted) {
          return;
        }
        setState({
          loading: false,
          error: error.message,
          data: null,
          stale: false,
          partial: false,
        });
      });

    return () => controller.abort();
  }, []);

  return state;
}
